import React from "react";
import { getStatusBadgeStyle, getStatusText } from "../../utils/statusUtils";

const StatusBadge = ({ status, language }) => {
  return (
    <span style={getStatusBadgeStyle(status)}>
      {getStatusText(status, language)}
    </span>
  );
};

export default StatusBadge;